/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";

import NotificationBell from "components/Navbars/NotificationBell.js";
import UserDropdown from "components/Dropdowns/UserDropdown.js";
import { useSidebar } from "contexts/SidebarContext.js";
import { useAuth } from "contexts/AuthContext.js";

export default function Sidebar() {
  const [collapseShow, setCollapseShow] = React.useState("hidden");
  const { isCollapsed, toggleSidebar } = useSidebar();
  const { logout, user } = useAuth();
  return (
    <>
      <nav className={`md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative z-10 py-4 transition-all duration-300 ${
        isCollapsed ? 'md:w-16 px-2' : 'md:w-64 px-6'
      }`}>
        <div className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
          {/* Header with Brand and Toggle */}
          <div className="flex items-center justify-between w-full md:pb-2">
            {/* Mobile Toggler */}
            <button
              className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
              type="button"
              onClick={() => setCollapseShow("bg-white m-2 py-3 px-6")}
            >
              <i className="fas fa-bars"></i>
            </button>

            {/* Brand */}
            <Link
              className={`text-left text-blueGray-600 inline-block text-sm uppercase font-bold p-4 px-0 transition-all duration-300 ${
                isCollapsed ? 'md:hidden' : 'whitespace-nowrap'
              }`}
              to="/dashboard"
            >
              BE<span className="text-lightBlue-500">D</span>CEO
            </Link>

            {/* Desktop Toggle Button */}
            <button
              className={`hidden md:flex items-center justify-center w-8 h-8 rounded-lg hover:bg-blueGray-100 transition-all duration-200 ${
                isCollapsed ? 'md:mx-auto' : ''
              }`}
              type="button"
              onClick={toggleSidebar}
              title={isCollapsed ? 'Expandir menú' : 'Contraer menú'}
            >
              <i className={`fas text-blueGray-400 text-sm transition-transform duration-200 ${
                isCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'
              }`}></i>
            </button>
          </div>
          {/* User */}
          <ul className="md:hidden items-center flex flex-wrap list-none">
            <li className="inline-block relative">
              <NotificationBell />
            </li>
            <li className="inline-block relative">
              <UserDropdown />
            </li>
          </ul>
          {/* Collapse */}
          <div
            className={
              "md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-2 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded " +
              collapseShow
            }
          >
            {/* Collapse header */}
            <div className="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200">
              <div className="flex flex-wrap">
                <div className="w-6/12 flex">
                  <button
                    type="button"
                    className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                    onClick={() => setCollapseShow("hidden")}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
                <div className="w-6/12 flex">
                  <Link
                    className="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                    to="/dashboard"
                  >
                    BE<span className="text-lightBlue-500">D</span>CEO
                  </Link>
                </div>
              </div>
            </div>

            {/* Divider */}
            <hr className="my-2 md:min-w-full" />
            {/* Heading */}
            <h6 className={`md:min-w-full text-blueGray-500 text-xs uppercase font-bold block pt-1 pb-3 no-underline ${
              isCollapsed ? 'md:hidden' : ''
            }`}>
              Backlog Management
            </h6>
            {/* Navigation */}

            <ul className="md:flex-col md:min-w-full flex flex-col list-none">
              <li className="items-center">
                <Link
                  className={
                    `text-xs uppercase py-3 font-bold block transition-all duration-200 ${
                      isCollapsed ? 'md:text-center md:px-0' : ''
                    } ` +
                    (window.location.pathname === "/dashboard"
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/dashboard"
                  title={isCollapsed ? "Dashboard" : ""}
                >
                  <i
                    className={
                      `fas fa-tv text-sm transition-all duration-200 ${
                        isCollapsed ? 'md:mr-0' : 'mr-2'
                      } ` +
                      (window.location.pathname === "/dashboard"
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>
                  <span className={isCollapsed ? 'md:hidden' : ''}>
                    {" "}Dashboard
                  </span>
                </Link>
              </li>

              <li className="items-center">
                <Link
                  className={
                    `text-xs uppercase py-3 font-bold block transition-all duration-200 ${
                      isCollapsed ? 'md:text-center md:px-0' : ''
                    } ` +
                    (window.location.pathname === "/tasks"
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/tasks"
                  title={isCollapsed ? "Tareas" : ""}
                >
                  <i
                    className={
                      `fas fa-tasks text-sm transition-all duration-200 ${
                        isCollapsed ? 'md:mr-0' : 'mr-2'
                      } ` +
                      (window.location.pathname === "/tasks"
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>
                  <span className={isCollapsed ? 'md:hidden' : ''}>
                    {" "}Tareas
                  </span>
                </Link>
              </li>

              <li className="items-center">
                <Link
                  className={
                    `text-xs uppercase py-3 font-bold block transition-all duration-200 ${
                      isCollapsed ? 'md:text-center md:px-0' : ''
                    } ` +
                    (window.location.pathname === "/projects"
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/projects"
                  title={isCollapsed ? "Proyectos" : ""}
                >
                  <i
                    className={
                      `fas fa-project-diagram text-sm transition-all duration-200 ${
                        isCollapsed ? 'md:mr-0' : 'mr-2'
                      } ` +
                      (window.location.pathname === "/projects"
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>
                  <span className={isCollapsed ? 'md:hidden' : ''}>
                    {" "}Proyectos
                  </span>
                </Link>
              </li>

              {/* AI Models - Admin Only */}
              {user && user.admin && (
              <li className="items-center">
                <Link
                  className={
                    `text-xs uppercase py-3 font-bold block transition-all duration-200 ${
                      isCollapsed ? 'md:text-center md:px-0' : ''
                    } ` +
                    (window.location.pathname === "/ai-models"
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/ai-models"
                  title={isCollapsed ? "Modelos IA" : ""}
                >
                  <i
                    className={
                      `fas fa-brain text-sm transition-all duration-200 ${
                        isCollapsed ? 'md:mr-0' : 'mr-2'
                      } ` +
                      (window.location.pathname === "/ai-models"
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>
                  <span className={isCollapsed ? 'md:hidden' : ''}>
                    {" "}Modelos IA
                  </span>
                </Link>
              </li>
              )}

              {/* Plans - Admin Only */}
              {user && user.admin && (
                <li className="items-center">
                  <Link
                    className={
                      `text-xs uppercase py-3 font-bold block transition-all duration-200 ${
                        isCollapsed ? 'md:text-center md:px-0' : ''
                      } ` +
                      (window.location.pathname === "/plans"
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/plans"
                    title={isCollapsed ? "Planes" : ""}
                  >
                    <i
                      className={
                        `fas fa-gem text-sm transition-all duration-200 ${
                          isCollapsed ? 'md:mr-0' : 'mr-2'
                        } ` +
                        (window.location.pathname === "/plans"
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    ></i>
                    <span className={isCollapsed ? 'md:hidden' : ''}>
                      {" "}Planes
                    </span>
                  </Link>
                </li>
              )}

              {/* Users - Admin Only */}
              {user && user.admin && (
                <li className="items-center">
                  <Link
                    className={
                      `text-xs uppercase py-3 font-bold block transition-all duration-200 ${
                        isCollapsed ? 'md:text-center md:px-0' : ''
                      } ` +
                      (window.location.pathname === "/users"
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/users"
                    title={isCollapsed ? "Usuarios" : ""}
                  >
                    <i
                      className={
                        `fas fa-users text-sm transition-all duration-200 ${
                          isCollapsed ? 'md:mr-0' : 'mr-2'
                        } ` +
                        (window.location.pathname === "/users"
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    ></i>
                    <span className={isCollapsed ? 'md:hidden' : ''}>
                      {" "}Usuarios
                    </span>
                  </Link>
                </li>
              )}

              {/* Leads - Admin Only */}
              {user && user.admin && (
                <li className="items-center">
                  <Link
                    className={
                      `text-xs uppercase py-3 font-bold block transition-all duration-200 ${
                        isCollapsed ? 'md:text-center md:px-0' : ''
                      } ` +
                      (window.location.pathname === "/leads"
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/leads"
                    title={isCollapsed ? "Leads" : ""}
                  >
                    <i
                      className={
                        `fas fa-address-book text-sm transition-all duration-200 ${
                          isCollapsed ? 'md:mr-0' : 'mr-2'
                        } ` +
                        (window.location.pathname === "/leads"
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    ></i>
                    <span className={isCollapsed ? 'md:hidden' : ''}>
                      {" "}Leads
                    </span>
                  </Link>
                </li>
              )}

              {/* Credit Analytics - Admin Only */}
              {user && user.admin && (
                <li className="items-center">
                  <Link
                    className={
                      `text-xs uppercase py-3 font-bold block transition-all duration-200 ${
                        isCollapsed ? 'md:text-center md:px-0' : ''
                      } ` +
                      (window.location.pathname === "/credit-analytics"
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/credit-analytics"
                    title={isCollapsed ? "Analíticas de Créditos" : ""}
                  >
                    <i
                      className={
                        `fas fa-chart-pie text-sm transition-all duration-200 ${
                          isCollapsed ? 'md:mr-0' : 'mr-2'
                        } ` +
                        (window.location.pathname === "/credit-analytics"
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    ></i>
                    <span className={isCollapsed ? 'md:hidden' : ''}>
                      {" "}Analíticas
                    </span>
                  </Link>
                </li>
              )}

              {/* Credits - visible to all authenticated users */}
              <li className="items-center">
                <Link
                  className={
                    `text-xs uppercase py-3 font-bold block transition-all duration-200 ${
                      isCollapsed ? 'md:text-center md:px-0' : ''
                    } ` +
                    (window.location.pathname === "/credits"
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/credits"
                  title={isCollapsed ? "Créditos" : ""}
                >
                  <i
                    className={
                      `fas fa-coins text-sm transition-all duration-200 ${
                        isCollapsed ? 'md:mr-0' : 'mr-2'
                      } ` +
                      (window.location.pathname === "/credits"
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>
                  <span className={isCollapsed ? 'md:hidden' : ''}>
                    {" "}Créditos
                  </span>
                </Link>
              </li>
            </ul>

            {/* Divider */}
            <hr className="my-4 md:min-w-full" />

            {/* Credit Balance Indicator */}
            {user && (() => {
              const isUnlimited = user.has_unlimited_credits;
              const balance = user.credit_balance;
              const monthly = user.monthly_credits;
              const percentage = (!isUnlimited && monthly > 0)
                ? Math.min(100, Math.round((balance / monthly) * 100))
                : 100;
              const isLow = !isUnlimited && monthly > 0 && balance < monthly * 0.2;
              const planName = user.plan?.name || 'FREE';

              return isCollapsed ? (
                <Link
                  to="/credits"
                  className="mb-4 flex justify-center hover:opacity-80 transition-opacity"
                  title={isUnlimited ? `Plan ${planName} · Ilimitado` : `Plan ${planName} · ${balance} créditos`}
                >
                  <i className={`fas fa-coins text-sm ${isLow ? 'text-orange-500' : 'text-blueGray-400'}`}></i>
                </Link>
              ) : (
                <Link
                  to="/credits"
                  className="mb-4 p-3 rounded-lg bg-blueGray-50 border border-blueGray-200 block hover:bg-blueGray-100 transition-colors"
                  title="Ver historial de créditos"
                >
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-xs font-bold text-blueGray-400 uppercase tracking-wide">
                      {planName}
                    </span>
                    {isUnlimited ? (
                      <span className="text-xs font-bold text-emerald-500">Ilimitado</span>
                    ) : (
                      <span className={`text-xs font-bold ${isLow ? 'text-orange-500' : 'text-blueGray-600'}`}>
                        {balance} créditos
                      </span>
                    )}
                  </div>
                  {!isUnlimited && (
                    <div className="w-full bg-blueGray-200 rounded-full h-1.5">
                      <div
                        className={`h-1.5 rounded-full transition-all duration-300 ${isLow ? 'bg-orange-400' : 'bg-lightBlue-400'}`}
                        style={{ width: `${percentage}%` }}
                      ></div>
                    </div>
                  )}
                </Link>
              );
            })()}

            {/* Notifications (desktop) */}
            <ul className="hidden md:flex md:flex-col md:min-w-full flex-col list-none mb-2">
              <li className="items-center">
                <div className={`flex items-center py-1 transition-all duration-200 ${isCollapsed ? 'justify-center' : ''}`}>
                  <NotificationBell />
                  <span className={`text-xs uppercase font-bold text-blueGray-700 ${isCollapsed ? 'hidden' : 'ml-1'}`}>
                    Notificaciones
                  </span>
                </div>
              </li>
            </ul>

            {/* Logout Button */}
            <ul className="md:flex-col md:min-w-full flex flex-col list-none">
              <li className="items-center">
                <button
                  className={`text-xs uppercase py-3 font-bold block transition-all duration-200 text-blueGray-700 hover:text-red-600 cursor-pointer w-full text-left ${
                    isCollapsed ? 'md:text-center md:px-0' : ''
                  }`}
                  onClick={logout}
                  title={isCollapsed ? "Cerrar Sesión" : ""}
                >
                  <i
                    className={`fas fa-sign-out-alt text-sm transition-all duration-200 text-blueGray-300 ${
                      isCollapsed ? 'md:mr-0' : 'mr-2'
                    }`}
                  ></i>
                  <span className={isCollapsed ? 'md:hidden' : ''}>
                    Cerrar Sesión
                  </span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}